/* List Of all the API URLS to be used to get DATA */
const BASE_URL = '/api/v1'
const BASE_URL_2 = '/api/v2'
const PRODUCT_URL = 'product'
// const CUSTOMER_URL = 'customer';
// const CUSTOMER_URL = 'local/customer';
// const PRODUCT_URL = 'local/product';
export default {
	/* BASE URL OF SITE */
	/* Authentication Api */
	login: `${BASE_URL}/authentication/login`,
	updatePassword: `${BASE_URL}/authentication/editpassword`,
	forgotPasswordUrl: `${BASE_URL}/authentication/request_password`,
	resetPassword: `${BASE_URL}/authentication/reset_password`,
	userVerificationUrl: `${BASE_URL}/authentication/hasAnExistingUser`,
	sendOTP: `${BASE_URL}/authentication/sendRegistrationOtp?phone_number=`,
	sendOTPEmail: `${BASE_URL}/authentication/emailRegistrationOtp`,
	verifyOTP: `${BASE_URL}/authentication/verifyRegistrationOtp?otp=`,
	verifyOTPEmail: `${BASE_URL}/authentication/verifyRegistrationEmail?otp=`,
	signUp: `${BASE_URL}/authentication/signup`,
	bankAccountLoginOtpSendUrl: `${BASE_URL}/authentication/bank/signUp`,
	tenantRegistrationUrl: `${BASE_URL}/authentication/bank/tenantRegistration`,
	bankAccountLoginOtpVerifyUrl: `${BASE_URL}/authentication/bank/verifyOtp`,
	signOut: `${BASE_URL}/authentication/signout`,
	/* Customer APi */
	getAddress: `${BASE_URL}/customer/getAddress`,
	addAddress: `${BASE_URL}/customer/addAddress`,
	editAddressUrl: `${BASE_URL}/customer/editAddress?addressId=`,
	removeAddress: `${BASE_URL}/customer/removeAddress?addressId=`,
	tenantRequest: `${BASE_URL}/customer/tenantRequest`,
	insertWishList: `${BASE_URL}/customer/insertWishList?chosen_country=`,
	getWishListUrl: `${BASE_URL}/customer/getWishList`,
	updateCustomer: `${BASE_URL}/customer/updateCustomer`,
	getCustomerDetailsUrl: `${BASE_URL}/customer/getCustomerDetails`,
	getTenantConfigurationsUrl: `${BASE_URL}/customer/tenantConfigurations`,
	insertRecentlyViewedProductsUrl: `${BASE_URL}/customer/insertRecentlyViewedProducts?product_id=`,
	getRecentlyViewedProductsUrl: `${BASE_URL}/customer/fetchRecentlyViewedProducts`,
	reviewUrl: `${BASE_URL}/customer/reviewProduct`,
	commentReviewUrl: `${BASE_URL}/customer/commentReview`,
	getReviewUrl: `${BASE_URL}/customer/getReview`,
	getNotificationUrl: `${BASE_URL}/customer/getNotification`,
	uploadPpUrl: `${BASE_URL}/customer/uploadProfilePicture`,
	updatePpUrl: `${BASE_URL}/customer/updateProfilePicture`,
	removePpUrl: `${BASE_URL}/customer/removeImage?url=`,
	uploadFilesUrl: `${BASE_URL}/customer/uploadFiles`,
	accountDeactivationUrl: `${BASE_URL}/customer/deactivateUser`,
	subscribeNewsletter: `${BASE_URL}/customer/subscribeNewsLetter`,
	unsubscribeNewsletter: `${BASE_URL}/customer/unsubscribeNewsLetter`,
	checkLoginStatusUrl: `${BASE_URL}/customer/checkLoginStatus`,
	reportAbuse: `${BASE_URL}/customer/reportAbuse?review_id=`,
	agentRequest: `${BASE_URL}/customer/agentRequest`,
	notifyMeUrl: `${BASE_URL}/customer/notifyMe`,
	/* Product Api */
	getCategories: `${BASE_URL}/product/categories`,
	getVendorUrl: `${BASE_URL}/product/vendor/local`,
	getSimilarVariantProductsUrl: `${BASE_URL}/product/group/`,
	// getAllProducts: `${BASE_URL}/product/allProducts`,
	getAllVendorProductsUrl: `${BASE_URL}/${PRODUCT_URL}/vendor/local/`,
	getAllProductsUrl: `${BASE_URL}/${PRODUCT_URL}/products`,
	getFilteredAllProductsUrl: `${BASE_URL}/${PRODUCT_URL}/getFilteredProducts`,
	getProductsByCategory: `${BASE_URL}/${PRODUCT_URL}/getProducts?categoryId=`,
	getProductsByIdsWithCategoryIdUrl: `${BASE_URL}/${PRODUCT_URL}/getProductsById?categoryId=`,
	getProductsByIdsUrl: `${BASE_URL}/${PRODUCT_URL}/getProductsById`,
	getSearchKeys: `${BASE_URL}/${PRODUCT_URL}/searchNames?subString=`,
	getSearchProductsUrl: `${BASE_URL}/${PRODUCT_URL}/searchProduct`,
	getFilteredSearchProductsUrl: `${BASE_URL}/${PRODUCT_URL}/getFilteredSearchProducts`,
	getFilters: `${BASE_URL}/${PRODUCT_URL}/getFilters`,
	getAllProductsFiltered: `${BASE_URL}/${PRODUCT_URL}/getFilteredProducts`,
	getFilteredProductsUrl: `${BASE_URL}/${PRODUCT_URL}/getFilteredSearchProducts`,
	getPromotions: `${BASE_URL}/${PRODUCT_URL}/promotions`,
	getPromotionalProducts: `${BASE_URL}/${PRODUCT_URL}/promotionalProducts?promotionId=`,
	getFashion: `${BASE_URL}/${PRODUCT_URL}/getFashion`,
	getMostSaled: `${BASE_URL}/${PRODUCT_URL}/getMostSaled`,
	verifyPromoCodeUrl: `${BASE_URL}/${PRODUCT_URL}/validatePromoCode?promo_code=`,
	// get rcommended products
	getRecommendedProductsUrl: `${BASE_URL}/customer/prediction?count=`,
	getByIdsUrl: `${BASE_URL}/product/getByIds`,
	/* Cart Apis */
	insertCartUrl: `${BASE_URL}/customer/insertCart?chosen_country=`,
	getCartUrl: `${BASE_URL}/customer/getCart`,
	clearCartUrl: `${BASE_URL}/customer/clearCart`,
	updateCartUrl: `${BASE_URL}/product/updateCart`, // without login update cart
	/* Order Apis */
	orderProductUrl: `${BASE_URL}/order/create`,
	getOrdersUrl: `${BASE_URL}/order/getOrders`,
	getAllPaymentOptionsUrl: `${BASE_URL}/order/options`,
	orderChargeUrl: `${BASE_URL}/order/finalize`,
	trackOrderUrl: `${BASE_URL}/order/trackOrder?order_number=`,
	sendOtpUrl: `${BASE_URL}/order/sendOtp?phone_number=`,
	sendOrderOTPEmailUrl: `${BASE_URL}/order/emailOrderOtp`,
	verifyOtpUrl: `${BASE_URL}/order/verifyOtp?otp=`,
	verifyOrderOTPEmailUrl: `${BASE_URL}/order/verifyOrderOtp?otp=`,
	stripePaymentUrl: `${BASE_URL}/order//stripe/paymentCheckout`,
	addStripeCardUrl: `${BASE_URL}/order/stripe/addCards`,
	getAllStripeCards: `${BASE_URL}/order/stripe/getAllCards`,
	deleteStripeCardUrl: `${BASE_URL}/order/stripe/deleteCard?card_id=`,
	razorPayPaymentCreateUrl: `${BASE_URL}/order/razorpayPaymentCreate`,
	razorPayPaymentFinalizeUrl: `${BASE_URL}/order/razorpayFinalize?order_number=`,
	verifyRazorPayPaymentUrl: `${BASE_URL}/order/razorpay/verifyPayment`,
	getReviewStatus: `${BASE_URL}/order/checkReviewStatus`,
	getOrderStatus: `${BASE_URL}/order/orderStatus`,
	giftCard: `${BASE_URL}/order/createGiftCard`,
	giftCardValidation: `${BASE_URL}/order/giftCardValidation`,
	orderReturnUrl: `${BASE_URL}/order/return`,
	checkVendorAvailabilityUrl: `${BASE_URL}/order/checkVendorAvailability`,
	// Vendor Apis
	vendorLoginUrl: `${BASE_URL}/authentication/vendor/login`,
	vendorRequest: `${BASE_URL}/authentication/vendor/signUp`,
	vendorPlans: `${BASE_URL}/customer/plans`,
	subscriptionPlanUrl: `${BASE_URL}/customer/activateSubscription`,
	subscriptionCreateUrl: `${BASE_URL}/order/vendorSubscription`,
	subscriptionPaymentUrl: `${BASE_URL}/customer/subscriptionPayment?payment_id=`,
	vendorAccountInformationUrl: `${BASE_URL}/customer/vendorBankAccountDetails`,
	vendorSignOutUrl: `${BASE_URL}/authentication/vendor/signout`,
	verifyClientUrl: `${BASE_URL}/authentication/email`,

	// new Vendor Apis
	vendorDocumentUploadUrl: `${BASE_URL}/customer/uploadDocument`,
	vendorInfoUrl: `${BASE_URL}/customer/vendorInfo`,
	vendorOrderListInfoUrl: `${BASE_URL}/customer/vendorOrders`,
	vendorRequestOtpUrl: `${BASE_URL}/authentication/requestOtp`,
	vendorLoginOtpUrl: `${BASE_URL}/authentication/vendor/loginViaOtp`,
	updateVendorInfoUrl: `${BASE_URL}/customer/updateVendorInfo`,
	/* Global Apis */
	tenantCountryChooserUrl: `${BASE_URL}/country/`,
	ifscCodeUrl: 'https://ifsc.razorpay.com/',
	countryChooserUrl: `${BASE_URL}/country/countries`,

	// Brand Apis
	brandDataUrl: `${BASE_URL}/brand/`,

	// Demo Payment Gateway Cards
	getCardsUrl: `${BASE_URL}/order/getCards`,
	addNewCardsUrl: `${BASE_URL}/order/addNewCards`,
	paymentCreateUrl: `${BASE_URL}/order/paymentCreate`,

	/* Agent Related Urls */
	agentSignUpRequest: `${BASE_URL}/authentication/agent/signUp`,
	agentLoginUrl: `${BASE_URL}/authentication/agent/login`,
	agentLogOutUrl: `${BASE_URL}/authentication/agent/signout`,
	agentInfoUrl: `${BASE_URL}/customer/agentInfo`,
	updateAgentDetailsUrl: `${BASE_URL}/customer/updateAgentInfo`,
	referVendorUrl: `${BASE_URL}/customer/referVendor`,
	referredVendorsUrl: `${BASE_URL}/customer/agentRefferedVendors`,

	/* Unomi Service Apis */
	eventServeUrl: `${BASE_URL_2}/analytics/create`,
	getSegmentsUrl: `${BASE_URL_2}/analytics/segments?unomiSessionId=`

}
